import { Injectable, effect, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DarkModeService {
  private readonly storageKey = 'dark-mode';
  private readonly defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

  readonly isDark = signal(this.getInitial());

  constructor() {
    effect(() => {
      const enabled = this.isDark();
      document.body.classList.toggle('dark-mode', enabled);
      localStorage.setItem(this.storageKey, JSON.stringify(enabled));
    });
  }

  toggle(): void {
    this.isDark.update(d => !d);
  }

  setDarkMode(enable: boolean): void {
    this.isDark.set(enable);
  }

  setDefault(): void {
    document.body.classList.toggle('dark-mode', this.defaultDark);
  }

  private getInitial(): boolean {
    const stored = localStorage.getItem(this.storageKey);
    return stored !== null ? JSON.parse(stored) : this.defaultDark;
  }
}
